import axios from "axios";
import jsbridge from "@kkmh/jsbridge";

export const native_kkmh = (window.kkmh) ? window.kkmh : {
    executeTasks: function () { }
};
export const kkmh = {
    //场景：app内，点‘返回’或滑动界面返回操作之后，往JS固定回调函数里注入 ‘状态通知信息’
    subscribeListenerOnViewBack: function (cb) {
        var listen = "subscribeListenerOnViewBack";
        window[listen] = function (res) {
            if (typeof res == "string") res = JSON.parse(res);
            kkmh.debug("[subscribeListenerOnViewBack返回]:", res);
            cb(res);
        };
    },
    //场景：接收王卡变更信息
    recivefreecardinfo: function (cb) {
        var listen = "recivefreecardinfo";
        window[listen] = function (res) {
            if (typeof res == "string") res = JSON.parse(res);
            kkmh.debug("[recivefreecardinfo返回]:", res);
            cb(res);
        };
    },
    //王卡字断
    getKKFlowType: function (res, mode) {
        res = typeof res == "string" ? JSON.parse(res) : res;
        res = Object.prototype.toString.call(res) == "object Object" ? res : {};
        if (mode == "recivefreecardinfo") {
            res.data = typeof res.data == "object" ? res.data : {};
            res = { freecard: { kkflowtype: res.data.kkflowtype } };
            //为了与getSysDeviceInfo res格式对齐
        }

        var freecard = res.freecard || {};
        return freecard.kkflowtype || "NotFree";
    },
    //输出控制台日志，线上自动屏蔽输出
    debug: function (a, b) {
        if (/www.kuaikanmanhua.com/.test(location.href)) {
            // return;
        }
        if (b) {
            // eslint-disable-next-line no-console
            console.log(a, b);
            return;
        }
        // eslint-disable-next-line no-console
        console.log(a);
    },
    //hybrid跳转
    requestHybrid: function (options) {
        if (!/kuaikan\//.test(navigator.userAgent.toLowerCase())) {
            // kkmh.debug('[请在客户端请求hybrid]', options)
            this.debug("[请在客户端请求hybrid]", options);
            return;
        }

        //requestHybrid时所传递过schema/tagname/param/callback
        var schema = options.schema || "kkhybrid";
        var tagname = options.tagname;
        var param = options.param;
        var callback = options.callback;

        //requestHybrid_wk 可以在接收is_del_nativecallback/debug
        var is_del_nativecallback = options.is_del_nativecallback === false ? false : true;
        var debug = options.debug === true ? true : false;
        /**
     * * jsbridge : 使用@kkmh/jsbridge@1.0.3 : https://wiki.quickcan.com/pages/viewpage.action?pageId=122488334
     * 参数
     * options={
     *    @schema               : 'kkhybrid',               //string-Y: kkmhhybrid, kkhybrid, kkaction, kkmh, window...
     *    @tagname              : 'login_win',              //string-Y: 方法名称
     *    @param                : '{id : 123}',             //object-Y: 参数
     *    @callback             : function(res, nativecallback_name){},     //function-N: 回调函数
     *    @is_del_nativecallback: true,                     //boolean-N: 默认true 删除客户端回调函数 (删除那个随机创建的函数名)
     *    @debug                : false,                    //boolean-N: 默认false 不输出log
     * }
     *
     * 返回:无
     * **/
        var obj = {
            schema: schema,       //string : kkmhhybrid, kkhybrid, kkaction ...
            tagname: tagname,      //string : 方法名称
            param: param,        //object : 所传递参数
            callback: function (res) {    //string : native调用js回调函数
                try {
                    /** * 使用try catch因为 login_result接口中返回的测试用户名中含有回车字符，服务端已删除该用户名回车字符
          前端角度，可用 decodeURIComponent(encodeURIComponent(res).replace(/\%0A/,""))解决
          由于不确定返回字串是否还会包含其他字符，所以该解决方案暂时搁置
          * **/
                    if (typeof res == "string") res = JSON.parse(res);
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn(`[${tagname}]res不是正确的json格式`, res);
                    res = {};
                }
                ///////浏览器环境下补助执行////////
                if (/hybrid_debug=true/.test(location.href)) {
                    // eslint-disable-next-line no-console
                    console.log(`[${tagname}返回]`, JSON.parse(JSON.stringify(res)));
                }
                callback && callback(res);
            },
            is_del_nativecallback: is_del_nativecallback,
            debug: true
        };
        ///////浏览器环境下补助执行////////
        if (/hybrid_debug=true/.test(location.href)) {
            // eslint-disable-next-line no-console
            console.log(obj);
            obj.debug = true;
            callback && callback();
        }
        //******* 谷歌浏览器模拟端内执行 *******
        if(/kuaikan\//.test(navigator.userAgent.toLowerCase()) && /kuaikan-simulation$/.test(navigator.userAgent.toLowerCase()) && window.webkit){
            window.webkit.messageHandlers.kkHybridBridge.postMessage(obj);
        }
        jsbridge(obj);
    },
    popNativeLogin: function (cb) {
        kkmh.requestHybrid({
            tagname: "logout",
            callback: function (res) {
                kkmh.requestHybrid({
                    tagname: "login_win",
                    callback: function (res) {
                        if (res.data && res.data.status == 1) { //已登陆
                            cb && cb();
                            return false;
                        }
                    },
                });
            },
        });
    },
    popH5Login: function (opt) {
        var url_h5 = /env=staging/.test(location.href) ? "/webapp/login/test_login.html" : "/webapp/login/login.html"; //必须用redirect参数，服务器登录成功后输出的脚本里用此参数来在cookie里获取后在转向的，pc也用了此redirect字段
        var url = encodeURIComponent(location.href);

        location.href = url_h5 + "?redirect=" + url;
    },
    //返回UA
    ua: function () {
        var userAgent = navigator.userAgent.toLowerCase();
        var is_iphone_qqnative = (/(iphone|ipod|ipad)/i.test(userAgent) && / QQ/i.test(navigator.userAgent));
        var is_android_qqnative = (/android/.test(userAgent) && /\sQQ/i.test(navigator.userAgent) && /QQ/i.test((navigator.userAgent).split("MQQBrowser")));

        return {
            iphone: /(iphone|ipod|ipad)/i.test(userAgent),
            android: /android/.test(userAgent),
            weixin: /micromessenger/.test(userAgent),
            weibo: /weibo/.test(userAgent),
            // qqnative: /qq\//.test(userAgent),
            qqnative: (is_android_qqnative || is_iphone_qqnative),
            qq: /qq/.test(userAgent),
            kkmh: /kuaikan\//.test(userAgent),
            alipay: /alipay/.test(userAgent),
            meipai: /com.meitu.mtmv/.test(userAgent),
            pc: !/(iphone|ipod|ipad|android|webos|blackberry)/.test(userAgent),
        };
    },
    //获取url携带参数
    qs: function () {
        var assoc = {};
        var decode = function (s) {
            return decodeURIComponent(s.replace(/\+/g, " "));
        };
        var queryString = location.search.substring(1);
        var keyValues = queryString.split("&");
        for (var i in keyValues) {
            var key = keyValues[i].split("=");
            if (key.length > 1) {
                assoc[decode(key[0])] = decode(key[1]);
            }
        }
        return assoc;
    },
    //显示错误提示
    showTips2: function (text, last, duration) {
        var timer, tips;
        var tpl = `<div class="error-tips" id="mod_tips_pop"><span>${tips}</span></div>`;
        if ($("#css_tips_pop").length == 0) { //初始化样式
            var css_text = ".error-tips{width:100%;left:0;top:70%;margin-top:-20px;position:fixed;z-index:5201;text-align:center;}.error-tips span{background-color:rgba(0,0,0,0.8);padding:8px 12px;display:inline-block;margin:0 auto;color:#FFFFFF;border-radius:4px;font-size:14px;}";
            $("head").append($('<style type="text/css" id="css_tips_pop">' + css_text + "</style>"));
        }

        last = last || 2000;
        duration = duration || 1000;
        $("#mod_tips_pop").remove();
        $("body").append($(tpl.replace(/\${tips}/, text || "")));

        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        var node = $("#mod_tips_pop");

        if (last > 0) { //last为0 表示一直显示
            timer = setTimeout(function () {
                if (duration > 0) {
                    node.animate({
                        "opacity": 0
                    }, {
                        "duration": duration,
                        "complete": function () {
                            node.remove();
                        }
                    });
                } else {
                    node.remove();
                }
            }, last);
        }
    },
    //显示错误提示
    showTips: function (text, last, duration) {
    //1.初始化样式
        if (!document.getElementById("css_tips_pop")) {
            var css = document.createElement("style");
            css.type = "text/css";
            css.id = "css_tips_pop";
            css.innerHTML =
        ".error-tips{width:100%;left:0;top:70%;margin-top:-20px;position:fixed;z-index:5201;text-align:center;}.error-tips span{background-color:rgba(0,0,0,0.8);padding:8px 12px;display:inline-block;margin:0 auto;color:#FFFFFF;border-radius:4px;font-size:14px;}\
                  .error-tips-ani {animation: error-tips-ani 1s ease-in-out 1;-webkit-animation: error-tips-ani 1s ease-in-out 1;opacity:0;}\
                  @keyframes error-tips-ani {from {opacity:1;}to {opacity:0;}}\
                  @-webkit-keyframes error-tips-ani {from {opacity:1;}to {opacity:0;}}";
            document.getElementsByTagName("head")[0].appendChild(css);
        }

        last = last || 2000;
        duration = duration || 1000;

        if (document.getElementById("mod_tips_pop")) {
            document.getElementById("mod_tips_pop").parentNode.removeChild(document.getElementById("mod_tips_pop"));
        }
        //'<div class="error-tips" id="mod_tips_pop"><span>${tips}</span></div>';
        var div = document.createElement("div");
        var span = document.createElement("span");
        var spantext = document.createTextNode(text);
        div.id = "mod_tips_pop";
        div.className = "error-tips";
        span.appendChild(spantext);
        div.appendChild(span);
        document.body.appendChild(div);

        setTimeout(function () {
            div.className = "error-tips error-tips-ani";
            setTimeout(function () {
                if (document.getElementById("mod_tips_pop")) {
                    document.getElementById("mod_tips_pop").parentNode.removeChild(document.getElementById("mod_tips_pop"));
                }
            }, duration);
        }, last);
    },
    /* 客户端分享
      kkmh.nativeShare({
          title   : '这里领福利！',
          desc    : '主人，使用这个代金券，可以免费看漫画哟~',
          imgUrl  : '', //空则用快看logo
          link    : 'https://www.baidu.com',
      });
  */
    nativeShare: function (sharedata) {
        var sharetype = sharedata.sharetype ? sharedata.sharetype : {};
        var data = {
            data: {
                share: {
                    shareImageUrl: sharedata.shareimageurl ? sharedata.shareimageurl : "",
                    shareType: {
                        qq: sharetype.qq ? sharetype.qq : 0, //0为网页 1为图片
                        moments: sharetype.moments ? sharetype.moments : 0, //0为网页 1为图片
                        weibo: sharetype.weibo ? sharetype.weibo : 0, //0为网页 1为图片
                        qqZone: sharetype.qqzone ? sharetype.qqzone : 0, //0为网页 1为图片
                        weChat: sharetype.wechat ? sharetype.wechat : 0, //0为网页 1为图片
                    },
                    title: sharedata.title,
                    desc: sharedata.desc,
                    imgUrl: sharedata.imgurl ? sharedata.imgurl : "https://f12stag.kkmh.com/label/170907/mQRSkZKmF.jpg", //icon地址
                    link: sharedata.link,
                },
                shareImageUrl: sharedata.shareimageurl ? sharedata.shareimageurl : "",
                shareType: {
                    qq: sharetype.qq ? sharetype.qq : 0, //0为网页 1为图片
                    moments: sharetype.moments ? sharetype.moments : 0, //0为网页 1为图片
                    weibo: sharetype.weibo ? sharetype.weibo : 0, //0为网页 1为图片
                    qqZone: sharetype.qqzone ? sharetype.qqzone : 0, //0为网页 1为图片
                    weChat: sharetype.wechat ? sharetype.wechat : 0, //0为网页 1为图片
                },
                title: sharedata.title,
                desc: sharedata.desc,
                imgUrl: sharedata.imgurl ? sharedata.imgurl : "https://f12stag.kkmh.com/label/170907/mQRSkZKmF.jpg", //icon地址
                link: sharedata.link,
            }
        };
        kkmh.requestHybrid({
            // schema: 'kkaction',
            tagname: "share",
            param: data,
            callback: function (res) {
                sharedata.callback(res);
            }
        });
    },
    /*微信分享
      kkmh.wxShare({
          title   : '这里领福利！',
          desc    : '主人，使用这个代金券，可以免费看漫画哟~',
          imgUrl  : '', //空则用快看logo
          link    : 'https://www.baidu.com',
      });
  */
    wxShare: function (sharedata) {
        if (!/micromessenger\//.test(navigator.userAgent.toLowerCase())) {
            return;
        }
        if (/kuaikanminiprogram/.test(location.href.toLowerCase())) {
            return;
        }

        // 动态加载js文件
        function getScript(src, cb) {
            var script = document.createElement("script");
            var script0 = document.getElementsByTagName("script")[0];
            script.async = 1;
            script.src = src;
            script0.parentNode.insertBefore(script, script0);
            script.onload = function () {
                cb && cb();
            };
        }

        /**微信分享注册参数*/
        function wxsdk(wxcfg) {
            // 微信配置
            wx.config({
                debug: false,
                appId: wxcfg.appId,
                timestamp: wxcfg.timestamp, // 上一次生成的时间戳
                nonceStr: wxcfg.nonceStr, // 上一步中的字符串
                signature: wxcfg.signature, // 上一步生成的签名
                jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline", "onMenuShareQQ", "onMenuShareWeibo", "onMenuShareQZone"] // 功能列表，我们要使用JS-SDK的神噩梦功能
            });

            // 调用接口
            wx.ready(function () {
                // 获取“分享给朋友”
                wx.onMenuShareAppMessage({
                    title: wxcfg.title, // 分享标题
                    desc: wxcfg.desc, // 分享描述
                    link: wxcfg.link, // 分享的url,以http或https开头
                    imgUrl: wxcfg.imgUrl, // 分享图标的url,以http或https开头
                    type: "link", // 分享类型，music、video或link，不填默认为 link
                    success: function () {
                        // eslint-disable-next-line no-console
                        console.log("分享完成");
                    },
                    cancel: function () {
                        // eslint-disable-next-line no-console
                        console.log("取消分享");
                    },
                    trigger: function () {
                        // eslint-disable-next-line no-console
                        console.log("点击发送给朋友");
                    }
                });

                // 获取“分享到朋友圈”
                wx.onMenuShareTimeline({
                    title: wxcfg.title, // 分享标题
                    link: wxcfg.link, // 分享的url,以http或https开头
                    imgUrl: wxcfg.imgUrl, // 分享图标的url,以http或https开头
                    success: function () {
                        // alert('分享到朋友圈完成');
                    },
                    cancel: function () {
                        // alert('取消分享到朋友圈');
                    }
                });

                // 获取“分享到QQ”
                wx.onMenuShareQQ({
                    title: wxcfg.title, // 分享标题
                    desc: wxcfg.desc, // 分享描述
                    link: wxcfg.link, // 分享链接
                    imgUrl: wxcfg.imgUrl, // 分享图标
                    success: function () {
                        // alert('分享到QQ完成');
                    },
                    cancel: function () {
                        // alert('取消分享到QQ分享');
                    }
                });

                // 获取"分享到腾讯微博"
                wx.onMenuShareWeibo({
                    title: wxcfg.title, // 分享标题
                    desc: wxcfg.desc, // 分享描述
                    link: wxcfg.link, // 分享链接
                    imgUrl: wxcfg.imgUrl // 分享图标
                });

                // 获取"分享到QQ空间"
                wx.onMenuShareQZone({
                    title: wxcfg.title, // 分享标题
                    desc: wxcfg.desc, // 分享描述
                    link: wxcfg.link, // 分享链接
                    imgUrl: wxcfg.imgUrl, // 分享图标
                    success: function () {
                        // alert('分享到QQ空间完成');
                    },
                    cancel: function () {
                        // alert('取消分享到QQ空间');
                    }
                });

            });
        }

        //微信分享获取ticket
        function settingWx(sharedata) {
            if (sharedata.wechat_ticket) {
                var wx_cfg = {
                    appId: sharedata.wechat_ticket.appId,
                    timestamp: sharedata.wechat_ticket.timestamp,
                    nonceStr: sharedata.wechat_ticket.nonceStr,
                    signature: sharedata.wechat_ticket.signature,
                    title: sharedata.title,
                    desc: sharedata.desc,
                    imgUrl: sharedata.imgurl ? sharedata.imgurl : "https://f12stag.kkmh.com/label/170907/mQRSkZKmF.jpg", //icon地址
                    link: sharedata.link ? sharedata.link : location.href,
                };
                wxsdk(wx_cfg);
                return;
            }
            var share = {
                title: sharedata.title,
                desc: sharedata.desc,
                imgUrl: sharedata.imgurl ? sharedata.imgurl : "https://f12stag.kkmh.com/label/170907/mQRSkZKmF.jpg", //icon地址
                link: sharedata.link ? sharedata.link : location.href,
            };

            //ticket获取
            var param = {
                origurl: location.href.split("#")[0], //必需为当前域名和路径，因为要生成签名之类的算法
            };
            // param = $.param(param); //会对url格式化
            axios({
                method: "get",
                url: "/comics/weixin/ticket",
                params: param,

            }).then(resp => {
                // eslint-disable-next-line no-console
                console.log("获取wx-ticket————", resp);
                // var resp = resp.data;
                // eslint-disable-next-line no-console
                console.log("获取wx-ticket222————", resp);
                var resp = resp.status ? resp.data : resp;

                if (resp.code == 200) {
                    var wx_ticket = resp.data.wx_ticket;
                    var wx_cfg = {
                        appId: wx_ticket.APPID,
                        timestamp: wx_ticket.timestamp,
                        nonceStr: wx_ticket.wxnonceStr,
                        signature: wx_ticket.wxSha1,
                        title: share.title,
                        desc: share.desc,
                        link: share.link, //wx_ticket.wxurl,
                        imgUrl: share.imgUrl
                    };
                    wxsdk(wx_cfg);

                } else {
                    // eslint-disable-next-line no-console
                    console.log("[获取wx-ticket失败]:", resp);

                }
            }).catch(resp => {
                // eslint-disable-next-line no-console
                console.log("[获取wx-ticket失败]:", resp);
            });
        }

        getScript("//res.wx.qq.com/open/js/jweixin-1.0.0.js", function () {
            settingWx(sharedata);
        });
    },
    //相当于jquery $(function(){}), dom构件之后
    $: function (fun) {
        if (document.addEventListener) {
            document.addEventListener("DOMContentLoaded", fun, false);
        } else {
            document.onreadystatechange = function () {
                if (document.readyState == "loader" || document.readyState == "complete" || document.readyState == "interactive") {
                    fun();
                }
            };
        }
    },
    doDownApp: function () {
        var url = "https://app.admki.com/Kuaikan_release_official.apk";
        if (kkmh.ua().iphone) {
            url = "https://itunes.apple.com/cn/app/kuai-kan-man-hua/id906936224?pt=117777462&mt=8&ct=official";
        }
        location.href = url;
        return false;
    },
    // imgLoader
    imageLoader: function (options) {
        var loaded = 0,
            imageUrls = options.items,
            count = imageUrls.length,
            progress = options.progress;

        loadImage(loaded);

        function loadImage(index) {
            if (index < count) {
                var img = new Image();
                img.src = imageUrls[index];

                img.onload = function () {
                    loaded++;
                    progress && progress(Math.round(loaded / count * 100) + "%");
                    loadImage(loaded);
                };
                img.onerror = function () {
                    loaded++;
                    progress && progress(Math.round(loaded / count * 100) + "%");
                    loadImage(loaded);
                };
            } else {
                options.callback();
            }
        }
    },
    //格式话头像
    formatAvatar: function (imgsrc) {
        if (!/(iphone|ipod|ipad)/i.test(navigator.userAgent.toLowerCase())) {
            return imgsrc;
        }
        if (/webp-w180/.test(imgsrc) && !/jpg/.test(imgsrc)) {
            return imgsrc + ".jpg";
        }
        if (/webp/.test(imgsrc) && !/jpg/.test(imgsrc)) {
            return imgsrc + "-c.w170.jpg";
        }
        return imgsrc;
    },
    //设置窗口不动
    setHtmlBodyHidden: function (flag) {
        if (flag) {
            document.documentElement.className = "overhidden";
            document.body.className = "overhidden";
        } else {
            document.documentElement.className = "";
            document.body.className = "";
        }
    },
};



// WEBPACK FOOTER //
// ./src/assets/js/common/kkmh_wk.js